// Reverse Charge Mechanism (RCM) is not a free-for-all toggle: under Sec 9(3) CGST
// (Notification 13/2017-CT(R) and amendments) it only attaches to a notified list of
// services. A vendor supplying, say, plumbing or gardening can never be "RCM applicable".
//
// Vendor categories are society-defined free text, so eligibility is decided by matching
// the category label against the keywords below. Add keywords here when a society names a
// notified service in a way we don't yet recognise.

export const RCM_SERVICES = [
    {
        key: 'security',
        label: 'security services',
        keywords: ['security', 'security guard', 'security agency', 'watchman', 'bouncer'],
    },
    {
        key: 'gta',
        label: 'goods transport agency services',
        keywords: ['goods transport', 'gta', 'transporter', 'transport agency', 'freight', 'logistics'],
    },
    {
        key: 'legal',
        label: 'legal services by an advocate',
        keywords: ['legal', 'advocate', 'lawyer', 'law firm', 'counsel'],
    },
    {
        key: 'arbitral',
        label: 'services of an arbitral tribunal',
        keywords: ['arbitral', 'arbitration', 'arbitrator'],
    },
    {
        key: 'motor-vehicle',
        label: 'renting of motor vehicle',
        keywords: ['motor vehicle', 'vehicle rental', 'vehicle hire', 'cab', 'taxi', 'car rental', 'car hire'],
    },
    {
        key: 'sponsorship',
        label: 'sponsorship services',
        keywords: ['sponsorship', 'sponsor'],
    },
    {
        key: 'director',
        label: 'services by a director',
        keywords: ['director', 'board member'],
    },
    {
        key: 'insurance-agent',
        label: 'insurance agent services',
        keywords: ['insurance agent', 'insurance agency'],
    },
    {
        key: 'recovery-agent',
        label: 'recovery agent services',
        keywords: ['recovery agent', 'collection agent'],
    },
    {
        key: 'immovable-property',
        label: 'renting of immovable property by an unregistered supplier',
        keywords: ['renting of immovable property', 'immovable property', 'property rental', 'premises rent'],
    },
    {
        key: 'import',
        label: 'import of services',
        keywords: ['import of service', 'overseas service', 'foreign service'],
    },
    {
        key: 'government',
        label: 'services supplied by government or a local authority',
        keywords: ['government', 'municipal', 'local authority', 'statutory body'],
    },
];

// "Security  Services / Guards" -> "security services guards"
const normalise = (value) => String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

/**
 * Returns the notified RCM service matching a vendor category label, or null when the
 * category is outside the reverse-charge list.
 */
export const getRcmServiceForCategory = (categoryLabel) => {
    const label = normalise(categoryLabel);
    if (!label) return null;
    return RCM_SERVICES.find(service =>
        service.keywords.some(keyword => label.includes(normalise(keyword)))
    ) || null;
};

export const isRcmEligibleCategory = (categoryLabel) => Boolean(getRcmServiceForCategory(categoryLabel));

// Short hint for the form, e.g. "security, goods transport, legal, ...".
export const RCM_SERVICE_HINT = 'security, goods transport, legal/advocate, renting of motor vehicle, sponsorship, director, insurance/recovery agent and other notified services';
